import React from "react";

const Developer = () => {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4">
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#090C6A]">
            About Kamdhenu Lifespaces
          </h2>
          <div className="w-24 h-1 bg-[#090C6A] mx-auto mt-3 rounded"></div>
        </div>

        <p className="text-gray-700 leading-relaxed text-justify">
          Kamdhenu was established in 1955 under the leading guidance of Late
          Mr. Anantram Sabhlok. In its long tenure, the group (now Kamdhenu
          Realities) headed by Mr. Surinder Sabhlok along with Mr. Karan Sabhlok,
          has been constructing exceptional quality living and commercial
          edifices. Each and every project of ours is special and is nurtured,
          developed and built with lot of care. Our desire to grow and
          diversify can be gauged from the fact that we revel in finding new
          challenges which bring out the best in us. But while we develop and
          advance, we also make sure that we do not neglect our corporate social
          and environmental responsibalities. Quality & timely delivery are the
          promises that we keep with our customers. Better lifestyles,
          world class qualities, and vibrant edifices are the things that you
          can always expect from Kamdhenu Realities.
        </p>
      </div>
    </section>
  );
};

export default Developer;
